export default __webpack_public_path__ + "static/media/food.9a10a76c.svg";